<template>
  <v-container
    class="main"
    fill-height
  >
    <div
      v-if="loading"
      class="loader"
    >
      <v-progress-circular
        indeterminate
        color="primary"
      />
    </div>
    <v-row
      v-else
    >
      <v-col
        cols="12"
        sm="12"
        md="12"
        lg="8"
        xl="6"
        offset-lg="2"
        offset-xl="3"
        pt="0"
      >
        <h1>
          {{ $t('payment_callback.txt.title') }}
        </h1>
        <div class="description">
          <div v-if="content === 'cancel'">
            {{ $t('payment_callback.txt.cancel') }}
          </div>
          <div v-else-if="content.length > 0">
            {{ $t(`payment_callback.txt.${content}`) }}
          </div>
        </div>
        <v-btn
          outlined
          height="48"
          color="mid"
          @click="handleClick(content)"
        >
          <span>{{ $t('payment_callback.txt.button') }}</span>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
// import apiCalls from '@/helpers/apiCall'
// import api from '@/helpers/api'
import { mapActions } from 'vuex'
export default {
  name: 'DirectDebitCallback',
  props: {
    provider: {
      type: String,
      required: true
    },
    mandateNumber: {
      type: String,
      required: true
    },
    status: {
      type: String,
      required: true
    },
    template: {
      type: String,
      required: true
    },
    signature: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: true,
      content: ''
    }
  },
  async created() {
    switch (this.status) {
      // case 'ok':
      //   if (this.provider === 'twk') {
      //     await apiCalls
      //       .post(api.PaymentSetTwikeyDirectDebit, '', '')
      //       .then(response => {
      //         if (response.status == 200) {
      //           this.loading = false
      //           this.content = this.template
      //         } else {
      //           this.loading = false
      //           this.setSnackbar({
      //             showing: true,
      //             type: 'error',
      //             text: this.$t('payment_confirmation.txt.notification_error')
      //           })
      //           setTimeout(() => {
      //             this.$router.push({
      //               name: 'home'
      //             })
      //           }, 2000)
      //         }
      //       })
      //   }
      //   break
      case 'ok':
      case 'pending':
        this.loading = false
        // this.content = this.template
        this.$router.push({
          name: 'payment_confirmation'
        })
        break
      case 'fail':
      case 'cancel':
        this.content = 'cancel'
        this.loading = false
        break
    }
  },
  methods: {
    ...mapActions('notification', ['setSnackbar']),
    handleClick(e) {
      if (e === 'cancel') {
        this.$router.push({
          name: 'payment_method'
        })
      } else {
        this.$router.push({
          name: 'payment_confirmation'
        })
      }
    }
  }
}
</script>
<style lang="scss">
.main {
  .loader {
    text-align: center;
    padding-top: 48px;
    width: 100%;
  }
  h1 {
    margin-bottom: 22px;
    font-size: 3rem;
    font-weight: 300;
    line-height: normal;
    color: var(--v-dark-base);
    text-align: center;
  }
  .description {
    font-size: 0.875rem;
    color: var(--v-slate-base);
  }
  .v-btn {
    margin: 48px;
    height: 48px !important;
    border-radius: 5px;
    background-image: linear-gradient(
      to bottom,
      #266cab 0%,
      #01529c
    ) !important;
    span {
      font-size: 0.875rem;
      font-weight: bold;
      text-align: center;
      color: white !important;
    }
    width: 50%;
    &--disabled {
      background-image: none !important;
    }
  }
}
</style>